module.exports = __webpack_public_path__ + "static/img/2021中国领先地智慧企业云平台.a6c08049.jpg";